import * as React from 'react';
import Slider from 'react-slick';
import { styled } from '../../styles/stitches.config';
import { navigate, graphql, useStaticQuery, Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';

const OurStorySection = () => {
    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "betterdaysourstory" }) {
              childImageSharp {
                  gatsbyImageData
              }
            }
          }
        `
    )

    const image = getImage(data.allFile);

    // const imageData = data.allFile.childImageSharp.fluid;

    const GridSection = styled('section', {
        display: 'flex',
        '@bp1': {
            padding: '80px 20px',
        },
        '@bp2': {
            padding: '80px 20px',
        },
        '@bp4': {
            padding: '80px 160px',
        },
    });

    const GridInternalWrapper = styled('div', {
        display: 'grid',
        gridTemplateColumns: 'min-content auto',
        '@bp1': {
            gridTemplateColumns: 'repeat(1, 1fr)',
            gap: '48px',
        },
        '@bp2': {
            gap: '24px',
        },
        '@bp4': {
            gap: '48px',
        },
        '& h3': {
            fontSize: '16px',
            marginBottom: '12px',
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '.1em',
        },
        '& h2': {
            fontFamily: '$default',
            fontSize: '48px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& p': {
            marginTop: '20px',
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.5px',
            '@bp1': {
                marginTop: '20px',
                fontSize: '18px',
                letterSpacing: '0.5px',
            },
        },
        '& a': {
            margin: '48px 0 0 0',
            letterSpacing: '4px',
            fontFamily: '$lato',
            fontSize: '14px',
            textTransform: "uppercase",
            textDecoration: 'underline',
            textUnderlineOffset: '6px',
        },
        '& .ourStoryImage': {
            '& .gatsby-image-wrapper': {
                width: '30vw',
                height: '30vw',
                '@bp1': {
                    width: '100%',
                    height: '100%',
                },
            }
        },
        '& .ourStoryDetails': {
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
        }
    });

    return (
        <GridSection>
            <GridInternalWrapper>
                <div className='ourStoryImage'>
                    <GatsbyImage image={image} alt={'blah'} />
                </div>
                <div className='ourStoryDetails'>
                    <h3>Founding Story</h3>
                    <h2>Less, but Better</h2>
                    <p>Skincare should be simple, safe and smart - it is essential to not use too many products. The key is to embrace multi-tasking products that can target several skin-enhancing pathways at the same time.</p>
                    <p>Our Multi-Active Treatment Essence harnesses nourishing ingredients to deliver nutrients and treat our myriad of skin concerns with long term results.</p>
                    <Link style={{ textAlign: 'left' }} to={"/pages/our-story"}>Read More</Link>
                </div>
            </GridInternalWrapper>
        </GridSection>
    )
};

export default OurStorySection;
